"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "node_modules/lodash/isObject.js"(exports, module2) {
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module2.exports = isObject;
  }
});

// node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "node_modules/lodash/_freeGlobal.js"(exports, module2) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// node_modules/lodash/_root.js
var require_root = __commonJS({
  "node_modules/lodash/_root.js"(exports, module2) {
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// node_modules/lodash/now.js
var require_now = __commonJS({
  "node_modules/lodash/now.js"(exports, module2) {
    var root = require_root();
    var now = function() {
      return root.Date.now();
    };
    module2.exports = now;
  }
});

// node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "node_modules/lodash/_trimmedEndIndex.js"(exports, module2) {
    var reWhitespace = /\s/;
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {
      }
      return index;
    }
    module2.exports = trimmedEndIndex;
  }
});

// node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "node_modules/lodash/_baseTrim.js"(exports, module2) {
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    module2.exports = baseTrim;
  }
});

// node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "node_modules/lodash/_Symbol.js"(exports, module2) {
    var root = require_root();
    var Symbol2 = root.Symbol;
    module2.exports = Symbol2;
  }
});

// node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "node_modules/lodash/_getRawTag.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module2.exports = getRawTag;
  }
});

// node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "node_modules/lodash/_objectToString.js"(exports, module2) {
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module2.exports = objectToString;
  }
});

// node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "node_modules/lodash/_baseGetTag.js"(exports, module2) {
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module2.exports = baseGetTag;
  }
});

// node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "node_modules/lodash/isObjectLike.js"(exports, module2) {
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module2.exports = isObjectLike;
  }
});

// node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "node_modules/lodash/isSymbol.js"(exports, module2) {
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module2.exports = isSymbol;
  }
});

// node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "node_modules/lodash/toNumber.js"(exports, module2) {
    var baseTrim = require_baseTrim();
    var isObject = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = toNumber;
  }
});

// node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "node_modules/lodash/debounce.js"(exports, module2) {
    var isObject = require_isObject();
    var now = require_now();
    var toNumber = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce2(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module2.exports = debounce2;
  }
});

// src/components/WorkspaceSelector/index.ts
var WorkspaceSelector_exports = {};
__export(WorkspaceSelector_exports, {
  AddNewWorkspaceButton: () => AddNewWorkspaceButton,
  WorkspaceDropdownHeader: () => WorkspaceDropdownHeader,
  WorkspaceDropdownItem: () => WorkspaceDropdownItem,
  WorkspaceDropdownItems: () => WorkspaceDropdownItems,
  WorkspaceSelector: () => WorkspaceSelector
});
module.exports = __toCommonJS(WorkspaceSelector_exports);

// src/components/WorkspaceSelector/WorkspaceSelector.tsx
var import_react16 = __toESM(require("react"));
var import_classnames13 = __toESM(require("classnames"));

// src/components/Dropdown/Dropdown.tsx
var import_react3 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));

// src/components/Dropdown/DropdownContainer.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
function DropdownContainer({
  id,
  className,
  style,
  children
}) {
  return /* @__PURE__ */ import_react.default.createElement(
    "ul",
    {
      id,
      className: (0, import_classnames.default)(className, [
        "v2-flex v2-flex-col v2-h-auto v2-rounded-sm v2-shadow ",
        "v2-bg-white v2-absolute"
      ]),
      style
    },
    children
  );
}

// src/hook/use-detect-outside-click-hook.ts
var import_react2 = require("react");
function useDetectOutsideClick({
  container = document,
  containerRef,
  onDetect
}, deps) {
  (0, import_react2.useEffect)(() => {
    if (!(containerRef == null ? void 0 : containerRef.current))
      return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        onDetect == null ? void 0 : onDetect();
      }
    };
    container == null ? void 0 : container.addEventListener("mousedown", handleClickOutside);
    return () => {
      container == null ? void 0 : container.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef, ...deps]);
}

// src/components/Dropdown/Dropdown.tsx
function Dropdown(_a) {
  var _b = _a, {
    id,
    className,
    active: defaultActive,
    body,
    children,
    closeOnOutsideClick = true,
    disabled = false,
    onClick,
    containerAlignment = "center" /* Center */,
    containerId,
    containerClassName,
    containerRef,
    width = 210
  } = _b, otherProps = __objRest(_b, [
    "id",
    "className",
    "active",
    "body",
    "children",
    "closeOnOutsideClick",
    "disabled",
    "onClick",
    "containerAlignment",
    "containerId",
    "containerClassName",
    "containerRef",
    "width"
  ]);
  const ref = containerRef != null ? containerRef : (0, import_react3.useRef)(null);
  const bodyRef = (0, import_react3.useRef)(null);
  const [active, setActive] = (0, import_react3.useState)(defaultActive);
  (0, import_react3.useEffect)(() => {
    setActive(defaultActive);
  }, [defaultActive]);
  const toggleDropdown = () => {
    if (!disabled) {
      setActive(!active);
      onClick == null ? void 0 : onClick(!active);
    }
  };
  useDetectOutsideClick(
    {
      containerRef: ref,
      onDetect: () => {
        if (closeOnOutsideClick && active) {
          toggleDropdown();
        }
      }
    },
    [active]
  );
  const defaultStyle = { width };
  const containerStyle = (0, import_react3.useMemo)(() => {
    var _a2;
    if (bodyRef.current) {
      const buttonRect = (_a2 = bodyRef.current) == null ? void 0 : _a2.getBoundingClientRect();
      return __spreadValues({
        marginTop: buttonRect.height
      }, defaultStyle);
    }
    return __spreadValues({}, defaultStyle);
  }, [bodyRef.current]);
  return /* @__PURE__ */ import_react3.default.createElement(
    "div",
    __spreadValues({
      id,
      className: (0, import_classnames2.default)(className, ["v2-flex v2-flex-col"]),
      style: {
        alignItems: containerAlignment
      },
      ref
    }, otherProps),
    /* @__PURE__ */ import_react3.default.createElement(
      "div",
      {
        onClick: toggleDropdown,
        ref: bodyRef,
        className: "v2-h-full v2-w-full"
      },
      body
    ),
    (bodyRef == null ? void 0 : bodyRef.current) && /* @__PURE__ */ import_react3.default.createElement(
      DropdownContainer,
      {
        id: containerId,
        className: (0, import_classnames2.default)(containerClassName, ["v2-transition"], {
          "v2-animate-fade-in": active,
          "v2-hidden": !active
        }),
        style: containerStyle
      },
      children
    )
  );
}

// src/components/WorkspaceSelector/WorkspaceDropdownItems.tsx
var import_react5 = __toESM(require("react"));

// src/components/WorkspaceSelector/WorkspaceDropdownItem.tsx
var import_react4 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
function WorkspaceDropdownItem({
  id,
  keyString,
  name,
  category,
  active,
  onClick
}) {
  return /* @__PURE__ */ import_react4.default.createElement(
    "li",
    {
      id,
      key: keyString,
      className: (0, import_classnames3.default)(
        [
          "v2-flex v2-flex-1 v2-h-full v2-w-full v2-no-underline v2-cursor-pointer",
          "hover:v2-text-neutral-900 v2-font-normal focus:v2-text-neutral-900",
          "hover:v2-bg-yellow-100"
        ],
        {
          "v2-bg-yellow-100": active
        }
      ),
      onClick
    },
    /* @__PURE__ */ import_react4.default.createElement(
      "span",
      {
        className: (0, import_classnames3.default)("v2-px-4 v2-flex v2-flex-col v2-truncate", {
          "v2-py-5": !category,
          "v2-py-2.5": category
        })
      },
      category && /* @__PURE__ */ import_react4.default.createElement("span", { className: "v2-text-xs v2-text-neutral-500 v2-my-0.5" }, category),
      /* @__PURE__ */ import_react4.default.createElement(
        "span",
        {
          className: (0, import_classnames3.default)([
            "v2-text-base v2-truncate v2-text-neutral-900 ",
            "v2-font-circular v2-text-base"
          ])
        },
        name
      )
    )
  );
}

// src/components/WorkspaceSelector/WorkspaceDropdownItems.tsx
var import_classnames4 = __toESM(require("classnames"));
function WorkspaceDropdownItems({
  items,
  className,
  onClick
}) {
  const itemComponents = (0, import_react5.useCallback)(() => {
    const components = [];
    if (items) {
      items.forEach((item, key) => {
        components.push(
          /* @__PURE__ */ import_react5.default.createElement(
            WorkspaceDropdownItem,
            __spreadProps(__spreadValues({
              key,
              keyString: `${key}`
            }, item), {
              onClick: () => onClick == null ? void 0 : onClick(item)
            })
          )
        );
      });
      return components;
    }
  }, [items]);
  return /* @__PURE__ */ import_react5.default.createElement(
    "div",
    {
      className: (0, import_classnames4.default)(className, [
        "v2-max-h-64",
        "v2-overflow-y-scroll v2-overflow-x-hidden",
        "v2-scrollbar-thin v2-scrollbar-track-neutral-50",
        "v2-scrollbar-thumb-neutral-300 v2-scrollbar-thumb-rounded-full"
      ])
    },
    itemComponents()
  );
}

// src/components/DropdownSelector/DropdownSelector.tsx
var import_react13 = __toESM(require("react"));
var import_classnames10 = __toESM(require("classnames"));

// src/components/DropdownSelector/DropdownSelectorItems.tsx
var import_react10 = __toESM(require("react"));

// src/components/DropdownSelector/DropdownSelectorItem.tsx
var import_react9 = __toESM(require("react"));
var import_classnames8 = __toESM(require("classnames"));

// src/components/Checkbox/index.tsx
var import_react6 = __toESM(require("react"));
var import_styled = __toESM(require("@emotion/styled"));
var import_classnames5 = __toESM(require("classnames"));

// src/theme/colors.ts
var palette = {
  black: "#000000",
  white: "#FFFFFF",
  red: ["#F9DEDC", "#F0ADA8", "#E77B73", "#DE4A3F", "#C6413E"],
  orange: [
    "#FFEEE6",
    "#FFDCCC",
    "#FFB99A",
    "#FF9767",
    "#FF7435",
    "#FF5102",
    "#CC4102",
    "#993101",
    "#662001",
    "#331000"
  ],
  yellow: [
    "#F7F4EA",
    "#FFF6CC",
    "#FFEC9A",
    "#FFE367",
    "#FFD935",
    "#FFD002",
    "#CCA602",
    "#997D01",
    "#665301",
    "#332A00"
  ],
  green: [
    "#FAFFEF",
    "#E7F4CC",
    "#CFE999",
    "#B8DD67",
    "#A0D234",
    "#88C701",
    "#6D9F01",
    "#527701",
    "#365000",
    "#1B2800"
  ],
  turquoise: ["#E3F2F2", "#BADEDE", "#9ED0D1", "#4EA4A6", "#22A0AC", "#1C7E87"],
  blue: [
    "#F5F7FF",
    "#CCD6FF",
    "#9AADFF",
    "#6783FF",
    "#355AFF",
    "#0231FF",
    "#0227CC",
    "#011D99",
    "#011466",
    "#000A33"
  ],
  purple: ["#E6E5F0", "#B5B1D3", "#847CB6", "#675EA5", "#514983"],
  pink: ["#FFEFF4", "#FFD0DF", "#F2A6BE", "#EC799D", "#D0577D"],
  brown: ["#9B803D", "#8E652A", "#5B4028", "#473A31", "#2D241D", "#1C1616"],
  neutral: [
    "#F2F2F2",
    "#E2E3E7",
    "#C4C7CF",
    "#A7AAB8",
    "#898EA0",
    "#6C7288",
    "#565B6D",
    "#414452",
    "#2B2E36",
    "#16171B"
  ],
  magenta: [
    "#FFF8FF",
    "#F0CEEA",
    "#E19DD6",
    "#D16DC1",
    "#C23CAD",
    "#B30B98",
    "#A10A89",
    "#7D086A",
    "#5A064C",
    "#36032E"
  ]
};
var colors = {
  white: palette.white,
  black: palette.black,
  current: "currentColor",
  transparent: "transparent",
  neutral: {
    DEFAULT: palette.neutral[9],
    50: palette.neutral[0],
    100: palette.neutral[1],
    200: palette.neutral[2],
    300: palette.neutral[3],
    400: palette.neutral[4],
    500: palette.neutral[5],
    600: palette.neutral[6],
    700: palette.neutral[7],
    800: palette.neutral[8],
    900: palette.neutral[9]
  },
  red: {
    DEFAULT: palette.red[3],
    100: palette.red[0],
    300: palette.red[1],
    500: palette.red[2],
    700: palette.red[3],
    900: palette.red[4]
  },
  orange: {
    DEFAULT: palette.orange[5],
    50: palette.orange[0],
    100: palette.orange[1],
    200: palette.orange[2],
    300: palette.orange[3],
    400: palette.orange[4],
    500: palette.orange[5],
    600: palette.orange[6],
    700: palette.orange[7],
    800: palette.orange[8],
    900: palette.orange[9]
  },
  yellow: {
    DEFAULT: palette.yellow[5],
    50: palette.yellow[0],
    100: palette.yellow[1],
    200: palette.yellow[2],
    300: palette.yellow[3],
    400: palette.yellow[4],
    500: palette.yellow[5],
    600: palette.yellow[6],
    700: palette.yellow[7],
    800: palette.yellow[8],
    900: palette.yellow[9]
  },
  green: {
    DEFAULT: palette.green[5],
    50: palette.green[0],
    100: palette.green[1],
    200: palette.green[2],
    300: palette.green[3],
    400: palette.green[4],
    500: palette.green[5],
    600: palette.green[6],
    700: palette.green[7],
    800: palette.green[8],
    900: palette.green[9]
  },
  turquoise: {
    DEFAULT: palette.turquoise[4],
    100: palette.turquoise[0],
    300: palette.turquoise[1],
    500: palette.turquoise[2],
    600: palette.turquoise[3],
    700: palette.turquoise[4],
    900: palette.turquoise[5]
  },
  blue: {
    DEFAULT: palette.blue[5],
    50: palette.blue[0],
    100: palette.blue[1],
    200: palette.blue[2],
    300: palette.blue[3],
    400: palette.blue[4],
    500: palette.blue[5],
    600: palette.blue[6],
    700: palette.blue[7],
    800: palette.blue[8],
    900: palette.blue[9]
  },
  purple: {
    DEFAULT: palette.purple[3],
    100: palette.purple[0],
    300: palette.purple[1],
    500: palette.purple[2],
    700: palette.purple[3],
    900: palette.purple[4]
  },
  pink: {
    DEFAULT: palette.pink[3],
    100: palette.pink[0],
    300: palette.pink[1],
    500: palette.pink[2],
    700: palette.pink[3],
    900: palette.pink[4]
  },
  brown: {
    DEFAULT: palette.brown[3],
    50: palette.brown[0],
    100: palette.brown[1],
    300: palette.brown[2],
    500: palette.brown[3],
    700: palette.brown[4],
    900: palette.brown[5]
  },
  magenta: {
    DEFAULT: palette.magenta[5],
    50: palette.magenta[0],
    100: palette.magenta[1],
    200: palette.magenta[2],
    300: palette.magenta[3],
    400: palette.magenta[4],
    500: palette.magenta[5],
    600: palette.magenta[6],
    700: palette.magenta[7],
    800: palette.magenta[8],
    900: palette.magenta[9]
  }
};

// src/theme/typography.ts
var typography = {
  standard: "Lato"
};

// src/theme/index.ts
var theme = {
  colors,
  extend: {
    screens: {
      xxs: "320px",
      xs: "425px",
      // Widget mobile breakpoint
      wm: "500px"
    },
    fontSize: {
      xxs: [
        ".5rem",
        {
          lineHeight: "0.75rem"
        }
      ]
    },
    fontFamily: {
      sans: ["Circular Std", typography.standard, "sans-serif"],
      circular: ["Circular Std", "Arial", "san-serif"]
    },
    boxShadow: {
      top: "0 -4px 4px 0 rgba(166, 166, 166, 0.13)",
      around: "0 1px 10px 0 rgba(0, 0, 0, 0.16)",
      "3xl": "5px 3px 6px #00000029"
    },
    dropShadow: {
      text: "0px 3px 6px #00000029"
    },
    zIndex: {
      "99": 99
    },
    spacing: {
      "30": "7.5rem",
      "37": "9.375rem"
    },
    animation: {
      "fade-in-100": "fade-in .1s linear forwards",
      "fade-in-150": "fade-in .15s linear forwards",
      "fade-in": "fade-in .25s linear forwards",
      "fade-out-100": "fade-out .1s linear forwards",
      "fade-out-150": "fade-out .15s linear forwards",
      "fade-out": "fade-out .25s linear forwards",
      "fade-in-down-150": "fade-in-down .15s linear 1",
      "fade-in-down": "fade-in-down .25s linear 1",
      "fade-out-down-150": "fade-out-down .15s linear 1",
      "fade-out-down": "fade-out-down .25s linear 1",
      "fade-in-up-150": "fade-in-up .15s linear 1",
      "fade-in-up": "fade-in-up .25s linear 1",
      "fade-out-up-150": "fade-out-up .15s linear 1",
      "fade-out-up": "fade-out-up .25s linear 1",
      "fade-in-left-150": "fade-in-left .15s linear 1",
      "fade-in-left": "fade-in-left .25s linear 1",
      "fade-out-left-150": "fade-out-left .15s linear 1",
      "fade-out-left": "fade-out-left .25s linear 1",
      "fade-in-right-150": "fade-in-right .15s linear 1",
      "fade-in-right": "fade-in-right .25s linear 1",
      "fade-out-right-150": "fade-out-right .15s linear 1",
      "fade-out-right": "fade-out-right .25s linear 1",
      "rotate-360": "rotate-360 2s linear infinite"
    },
    keyframes: {
      "rotate-360": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" }
      },
      "fade-in": {
        "0%": { opacity: "0" },
        "100%": { opacity: "1" }
      },
      "fade-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0" }
      },
      "fade-in-down": {
        "0%": { opacity: "0", transform: "translateY(-20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-down": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(20px)" }
      },
      "fade-in-up": {
        "0%": { opacity: "0", transform: "translateY(20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-up": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(-20px)" }
      },
      "fade-in-left": {
        "0%": { opacity: "0", transform: "translateX(20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-left": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(-20px)" }
      },
      "fade-in-right": {
        "0%": { opacity: "0", transform: "translateX(-20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-right": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(20px)" }
      }
    }
  }
};

// src/components/Checkbox/index.tsx
var themes = {
  ["turquoise" /* Turquoise */]: {
    containerBorderColor: colors.turquoise[500],
    inputBorderColor: colors.turquoise[500],
    checkedBgColor: colors.turquoise[700]
  },
  ["yellow" /* Yellow */]: {
    containerBorderColor: colors.neutral[500],
    inputBorderColor: colors.neutral[500],
    checkedBgColor: colors.yellow[500],
    hoverBgColor: colors.yellow[50]
  }
};
var CheckboxContainer = import_styled.default.label`
  ${({ borderColor, hoverBgColor, disabled }) => {
  if (disabled) {
    return "";
  }
  return `
    &:hover input ~ span {
      border: 1px ${borderColor} solid;
      ${hoverBgColor ? `background: ${hoverBgColor}` : ""}
    }
  `;
}}
`;
var CheckboxInput = import_styled.default.input`
  ${({ borderColor }) => `
    &:checked ~ span {
      border: 1px ${borderColor} solid;
    }

    &:checked ~ span:after {
      display: flex;
    }
  `}
`;
var Checkmark = import_styled.default.span`
  ${({ bgColor }) => `
    &:after {
      content: '';
      display: none;
      width: 70%;
      height: 70%;
      background: ${bgColor};
      border-radius: 3px;
      margin: 15%;
    }
  `}
`;

// src/components/Tooltip/Bubble.tsx
var import_react7 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));

// src/components/Tooltip/Tooltip.tsx
var import_react8 = __toESM(require("react"));
var import_classnames7 = __toESM(require("classnames"));
var import_react_tiny_popover = require("react-tiny-popover");
var import_debounce = __toESM(require_debounce());

// src/components/DropdownSelector/DropdownSelectorBody.tsx
var import_react11 = __toESM(require("react"));
var import_classnames9 = __toESM(require("classnames"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faChevronDown = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
};

// src/components/DropdownSelector/DropdownSelectorBody.tsx
function DropdownSelectorBody({
  id,
  className,
  contentClassName,
  iconClassName,
  active,
  disabled,
  content,
  width
}) {
  return /* @__PURE__ */ import_react11.default.createElement(
    "div",
    {
      id,
      style: { width },
      className: (0, import_classnames9.default)(
        className,
        ["v2-group v2-border v2-border-solid v2-items-center"],
        {
          "v2-border-white hover:v2-border-yellow-500 v2-bg-white": !disabled,
          "v2-bg-neutral-50 v2-border-neutral-300 v2-text-neutral-300": disabled
        }
      )
    },
    /* @__PURE__ */ import_react11.default.createElement(
      "div",
      {
        className: (0, import_classnames9.default)(contentClassName, [
          "v2-px-4 v2-py-2 v2-flex v2-cursor-pointer",
          " v2-gap-x-2 v2-font-circular v2-select-none"
        ])
      },
      content,
      /* @__PURE__ */ import_react11.default.createElement(
        import_react_fontawesome.FontAwesomeIcon,
        {
          icon: faChevronDown,
          className: (0, import_classnames9.default)(
            iconClassName,
            ["!v2-w-[24px] !v2-h-5 v2-transition-transform v2-duration-400"],
            {
              "v2-filter v2-transform v2-rotate-180 v2-text-black": active,
              "v2-text-neutral-500 group-hover:v2-text-black": !disabled,
              "v2-text-neutral-300": disabled
            }
          )
        }
      )
    )
  );
}

// src/components/DropdownSelector/DropdownGroupSelector.tsx
var import_react12 = __toESM(require("react"));

// src/components/WorkspaceSelector/AddNewWorkspaceButton.tsx
var import_react14 = __toESM(require("react"));
var import_classnames11 = __toESM(require("classnames"));
function AddNewWorkspaceButton({
  text,
  onClick
}) {
  return /* @__PURE__ */ import_react14.default.createElement("li", { className: "v2-flex v2-text-center", onClick }, /* @__PURE__ */ import_react14.default.createElement(
    "button",
    {
      className: (0, import_classnames11.default)([
        "v2-font-bold v2-py-3 v2-text-xs v2-w-full hover:v2-text-neutral-900",
        "focus:v2-text-neutral-900 hover:!v2-bg-yellow-100 v2-cursor-pointer",
        "v2-border-none v2-bg-white v2-truncate"
      ])
    },
    text
  ));
}

// src/components/WorkspaceSelector/WorkspaceDropdownHeader.tsx
var import_react15 = __toESM(require("react"));
var import_classnames12 = __toESM(require("classnames"));
function WorkspaceDropdownHeader({
  title,
  viewAllText,
  onViewAllClick
}) {
  return /* @__PURE__ */ import_react15.default.createElement("li", { className: "v2-flex v2-flex-row v2-justify-between v2-py-2.5 v2-px-3.5" }, /* @__PURE__ */ import_react15.default.createElement("span", { className: "v2-flex-1 v2-text-xs v2-text-neutral-500 v2-font-bold" }, title), /* @__PURE__ */ import_react15.default.createElement(
    "span",
    {
      className: (0, import_classnames12.default)([
        "v2-text-xs v2-text-neutral-900 hover:v2-text-neutral-500",
        "v2-cursor-pointer v2-underline v2-truncate"
      ]),
      onClick: onViewAllClick
    },
    viewAllText
  ));
}

// src/components/WorkspaceSelector/WorkspaceSelector.tsx
function WorkspaceSelector(_a) {
  var _b = _a, {
    id,
    bodyText = "",
    className,
    itemsContainerClassName,
    dropdownProps,
    headerText = "WORKSPACES",
    viewAllText = "View all",
    addNewText = "+ Add a new workspace",
    items,
    disabled,
    bodyWidth = 200,
    dropdownWidth = 250,
    onClick,
    onViewAllClick,
    onAddNewClick,
    dropdownBodyProps = {}
  } = _b, otherProps = __objRest(_b, [
    "id",
    "bodyText",
    "className",
    "itemsContainerClassName",
    "dropdownProps",
    "headerText",
    "viewAllText",
    "addNewText",
    "items",
    "disabled",
    "bodyWidth",
    "dropdownWidth",
    "onClick",
    "onViewAllClick",
    "onAddNewClick",
    "dropdownBodyProps"
  ]);
  var _a2;
  const [active, setActive] = (0, import_react16.useState)(false);
  const onBodyClick = () => {
    setActive(!active);
    onClick == null ? void 0 : onClick();
  };
  const onItemClick = (item) => {
    var _a3;
    (_a3 = item.onClick) == null ? void 0 : _a3.call(item);
    setActive(false);
  };
  return /* @__PURE__ */ import_react16.default.createElement(
    Dropdown,
    __spreadValues({
      id,
      className: (0, import_classnames13.default)(className, "v2-select-none v2-font-circular"),
      containerAlignment: (_a2 = dropdownProps == null ? void 0 : dropdownProps.containerAlignment) != null ? _a2 : "flex-start" /* Start */,
      containerClassName: (0, import_classnames13.default)(
        dropdownProps == null ? void 0 : dropdownProps.containerClassName,
        "!v2-mt-11 v2-p-0 v2-rounded"
      ),
      containerId: dropdownProps == null ? void 0 : dropdownProps.id,
      body: /* @__PURE__ */ import_react16.default.createElement(
        DropdownSelectorBody,
        __spreadValues({
          content: /* @__PURE__ */ import_react16.default.createElement("span", { className: "!text-base v2-truncate v2-w-full v2-flex-1 v2-text-sm" }, bodyText),
          className: (0, import_classnames13.default)("h-100", {
            "!v2-border-yellow-500": active
          }),
          contentClassName: "v2-justify-between",
          active,
          disabled,
          width: bodyWidth
        }, dropdownBodyProps)
      ),
      width: dropdownWidth,
      active,
      disabled,
      onClick: onBodyClick
    }, otherProps),
    /* @__PURE__ */ import_react16.default.createElement(
      WorkspaceDropdownHeader,
      {
        title: headerText,
        viewAllText,
        onViewAllClick
      }
    ),
    /* @__PURE__ */ import_react16.default.createElement(
      WorkspaceDropdownItems,
      {
        items,
        className: itemsContainerClassName,
        onClick: onItemClick
      }
    ),
    /* @__PURE__ */ import_react16.default.createElement(AddNewWorkspaceButton, { text: addNewText, onClick: onAddNewClick })
  );
}
